"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useList = void 0;
const QueryList_1 = require("../../query/QueryList");
function useList(options) {
    return QueryList_1.useQueryList(options);
}
exports.useList = useList;
//# sourceMappingURL=useList.js.map